export default {
    callToAction: "Sign up for our JourneyBinder Newsletter",
    launchButton: "Start",
    formId: "blog_newsletter_signup",
    questions: [
        {
            question: "What's your full name?",
            type: "text",
            minLength: 2
        },
        {
            question: "Which email address shall we use?",
            small: "Don't worry, we're not going to spam you.",
            type: "email"
        },
        {
            question: "Which are your interests?",
            type: "single",
            answers: [
                {
                    answer: "Spiritual",
                    action: "continue",
                    key: "A"
                },
                {
                    answer: "Health",
                    action: "continue",
                    key: "B"
                },
                {
                    answer: "Education",
                    action: "continue",
                    key: "C"
                },
                {
                    answer: "Finance",
                    action: "continue",
                    key: "D"
                },
                {
                    answer: "Productivity Methodolgies",
                    action: "continue",
                    key: "E"
                }
            ]
        },
        {
            id: "thank-you",
            question: "You Rock! Wishing you all the Best!!!",
            type: "submit"
        }
    ]
};
